import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DesktopAppVersionInfo, DeviceInfo } from 'src/app/shared/models/device-info';
import { AppSettingsService } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class EdaraNativeService {

  edaraNativeServiceBaseUrl = '';

  constructor(private httpClient: HttpClient) {
    this.edaraNativeServiceBaseUrl = AppSettingsService.appSettings.edaraNativeService.baseUrl;
    if (this.edaraNativeServiceBaseUrl.endsWith('/')) {
      this.edaraNativeServiceBaseUrl = this.edaraNativeServiceBaseUrl.slice(0, -1);
    }
  }

  getDeviceInfoAsync(): Promise<DeviceInfo | undefined> {
    return firstValueFrom(
      this.httpClient.get<DeviceInfo>(this.edaraNativeServiceBaseUrl + '/api/device/info')
    ).catch(() => { return undefined; });
  }

  getVersionAsync(): Promise<DesktopAppVersionInfo | undefined> {
    return firstValueFrom(
      this.httpClient.get<DesktopAppVersionInfo>(this.edaraNativeServiceBaseUrl + '/version/desktop')
    ).catch(() => { return undefined; });
  }
}
